import { Button, Heading, Text } from "@ttc3k/trekker";
import { Flex } from "styled-system/jsx";

type PostOnboardingMessageProps = {
  emoji: string;
  headingText: string;
  message: string;
  buttonText: string;
  onClick: () => void;
};

export const PostOnboardingMessage = ({
  emoji,
  headingText,
  message,
  buttonText,
  onClick,
}: PostOnboardingMessageProps) => {
  return (
    <Flex
      flexDir={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      gap="400"
      pb="400"
    >
      <Flex
        flexDir={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        gap="250"
      >
        <Heading size="h3">{emoji}</Heading>
        <Heading size="h5">{headingText}</Heading>
        <Text visual="bodyRegular" textAlign="center" pt="100">
          {message}
        </Text>
      </Flex>
      <Button visual="primary" width="340px" size="lg" onClick={onClick}>
        {buttonText}
      </Button>
    </Flex>
  );
};
